import { BodyText } from "@/components/ui/Text";
import { Role } from "@/types/roles";
import { Practitioner } from "@curai/js-fhir-tools";
import { formatDate } from "date-fns";
import type { ChatMessage } from "../../types/chatMessageTypes";

interface HandoffMessageProps {
  message: ChatMessage;
}

export const HandoffMessage = ({ message }: HandoffMessageProps) => {
  const role = message.roleHandedoffTo ? Role[message.roleHandedoffTo] : null;
  const practitioner = new Practitioner(message.practitioner as object);
  return (
    <div className="flex flex-col gap-1 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        {practitioner.chatTitle} handed visit off to a {role}.
      </BodyText>
      <BodyText size="xs" textColor={"tertiary"}>
        {formatDate(new Date(message.created), "MM/dd/yyyy h:mm a")}
      </BodyText>
    </div>
  );
};
